module.exports = __webpack_public_path__ + "img/integral-rule2.e5bf440e.jpg";